import React from "react";
import { AiOutlineFile } from "react-icons/ai";
import { useDispatch } from "react-redux";
import { downloadPdf } from "../../actions/common";
import { UserButton } from "../Button";

export default ({ filename, payload }) => {
  const dispatch = useDispatch();

  const onClick = () => {
    dispatch(
      downloadPdf({
        fileType: "HTML",
        filename,
        ...payload,
      })
    );
  };

  return (
    <UserButton
      text="Download Html"
      className="btn btn-primary btn-sm"
      icon={<AiOutlineFile />}
      onClick={onClick}
    />
  );
};
